module.exports = __webpack_public_path__ + "img/video_cover.bf74caaa.png";